import { SYSTEM_KIND_LABEL } from "@/lib/messages";
import { LinkifiedText } from "@/components/LinkifiedText";

export default function SystemMessagesList({ items, testid = "system-messages" }) {
  if (items.length === 0) {
    return <div className="panel p-6 text-center label" data-testid={`${testid}-empty`}>No system messages</div>;
  }
  return (
    <div className="space-y-3" data-testid={testid}>
      {items.map(s => (
        <div key={s.message_id} className="panel p-4" data-testid={`system-msg-${s.message_id}`}>
          <div className="flex items-baseline justify-between gap-3 flex-wrap">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="sample-badge"
                style={{ background: "#eef2ff", color: "#3730a3", border: "1px solid #c7d2fe" }}>
                {SYSTEM_KIND_LABEL[s.system_kind] || "System"}
              </span>
              <p className="font-medium">{s.subject}</p>
            </div>
            <p className="label">{new Date(s.sent_at).toLocaleString()}</p>
          </div>
          <p className="mt-2 whitespace-pre-line text-sm leading-relaxed"
            style={{ color: "var(--text-dim)" }}><LinkifiedText text={s.body} /></p>
          {s.delivery_status && s.delivery_status !== "sent" && (
            <p className="label mt-2" style={{ color: "var(--text-dim)" }}>Email {s.delivery_status.replace("_", " ")}</p>
          )}
        </div>
      ))}
    </div>
  );
}
